import * as React from "react";
import {Link}     from "react-router-dom";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Select2}        from "@Common/ui-components/select-2/select-2";
import {buildUrlQuery}  from "@Common/utils/build-url-query";

import "./header-mobile.scss";

export const HeaderMobile = ({office, items, activeTab, queryParams, config}) => cs(
    consumeContext("routerHistory"),
    ({routerHistory}) => <div className="office-header-mobile-d3n">
        <div className="office-description">
            {office?.branchName ? (
                <div className="name" xd-qa-type="label" xd-qa-name="Branch Name">
                    {office?.branchName}
                </div>
            ) : (
                <div>Loading...</div>
            )}
            {office?.branchAddress1 && <div className="address" xd-qa-type="label" xd-qa-name="Address 1"> {office?.branchAddress1 } </div>}
            {office?.branchAddress2 && <div className="address" xd-qa-type="label" xd-qa-name="Address 2"> {office?.branchAddress2 } </div>}
            {office?.branchCity && <div className="address" xd-qa-type="label" xd-qa-name="City State Zip">{`${office?.branchCity}, ${office?.branchState} ${office?.branchZip}`}</div>}
            {office?.branchName && <><a
                className="office-edit"
                xd-qa-type="link"
                xd-qa-name="Edit"
                onClick={ ()=> (
                    routerHistory.replace(items.find((item) => activeTab === item.name)?.link + buildUrlQuery({
                        ...queryParams,
                        modal: "manage",
                        menu: "general"
                    }))
                )}
                >
                    Edit
            </a>
            <Link
                to={"/account/admin/user?office=" + office.id_branch}
                xd-qa-type="link"
                xd-qa-name="View Users"
                className="link-agent"
            >
                View Users
            </Link></>}
        </div>
        {Select2({
            isSelected: (item) => activeTab === item.name,
            getLabel: (item) => item.linkLabel,
            onSelect: (item) => routerHistory.replace(item.link + buildUrlQuery({
                    ...office.id_branch && {
                        office: office.id_branch
                    },
                })
            ),
            xdQaName: "Tab Dropdown",
            className: "question",
            list: config,
            disableClearingSelection: true,
        })}
    </div>
);